/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { DrawPass } from './draw';
import { PickPass } from './pick';
import { MultiSamplePass } from './multi-sample';
var Passes = /** @class */ (function () {
    function Passes(webgl, attribs) {
        if (attribs === void 0) { attribs = {}; }
        this.webgl = webgl;
        var gl = webgl.gl;
        this.draw = new DrawPass(webgl, gl.drawingBufferWidth, gl.drawingBufferHeight, attribs.enableWboit || false);
        this.pick = new PickPass(webgl, this.draw, attribs.pickScale || 0.25);
        this.multiSample = new MultiSamplePass(webgl, this.draw);
    }
    Passes.prototype.updateSize = function () {
        var gl = this.webgl.gl;
        this.draw.setSize(gl.drawingBufferWidth, gl.drawingBufferHeight);
        this.pick.syncSize();
        this.multiSample.syncSize();
    };
    return Passes;
}());
export { Passes };
//# sourceMappingURL=passes.js.map